import React, { useState, useEffect, useRef } from 'react';
import { FloatingLabel, Form } from 'react-bootstrap';

let autoComplete;

const loadScript = (url, callback) => {
  let script = document.createElement('script');
  script.type = 'text/javascript';

  if (script.readyState) {
    script.onreadystatechange = function () {
      if (script.readyState === 'loaded' || script.readyState === 'complete') {
        script.onreadystatechange = null;
        callback();
      }
    };
  } else {
    script.onload = () => callback();
  }

  script.src = url;
  document.getElementsByTagName('head')[0].appendChild(script);
};

const SearchLocationInput = (props) => {
  const { setLocation, addr } = props;

  const [query, setQuery] = useState('');
  const autoCompleteRef = useRef(null);

  function handleScriptLoad(updateQuery, autoCompleteRef) {
    // Defensive checks: ensure Google Maps Places library is available before using it
    if (
      !window.google ||
      !window.google.maps ||
      !window.google.maps.places ||
      typeof window.google.maps.places.Autocomplete !== 'function'
    ) {
      console.error(
        'Google Maps Places Autocomplete is not available. Verify API key and that libraries=places is included.'
      );
      return;
    }

    autoComplete = new window.google.maps.places.Autocomplete(autoCompleteRef.current, {
      componentRestrictions: { country: ['br', 'us', 'py', 'ar'] }
    });

    // setFields is deprecated in newer API versions; keep for backward compatibility if present
    if (typeof autoComplete.setFields === 'function') {
      autoComplete.setFields(['address_components', 'formatted_address', 'geometry']);
    }

    autoComplete.addListener('place_changed', () => handlePlaceSelect(updateQuery));
  }

  async function handlePlaceSelect(updateQuery) {
    const place = autoComplete.getPlace();

    if (!place || !place.geometry || !place.geometry.location) {
      console.warn("Lugar inválido ou sem coordenadas.");
      return;
    }

    const query = place.formatted_address;
    const lat = place.geometry.location.lat();
    const lng = place.geometry.location.lng();

    updateQuery(query);
    setLocation(query, lat, lng);
  }

  useEffect(() => {
    loadScript(
      `https://maps.googleapis.com/maps/api/js?key=${process.env.REACT_APP_GOOGLE_API_KEY}&libraries=places`,
      () => handleScriptLoad(setQuery, autoCompleteRef)
    );
  }, []);

  useEffect(() => {
    if (addr) {
      setQuery(addr);
    }
  }, [addr]);

  return (
    <>
      <FloatingLabel
        controlId="floatingAddress"
        label="Endereço"
        className="mb-3"
      >
        <Form.Control
          type="text"
          ref={autoCompleteRef}
          onChange={(event) => setQuery(event.target.value)}
          placeholder="Endereço"
          value={query}
        />
      </FloatingLabel>
    </>
  );
};

export default SearchLocationInput;
